/************
 * Service Class 
 * File Name ...: servicedef.service.ts
 * Generated By : ianday on 10/30/23
 * Date ........: 10/30/23
/************/
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { ServiceDef } from '../models/service-def';
import { Settings } from './settings';
import {ServiceRegion} from "../models/service-region";
import {Region} from "../models/region";
import {UnitOfMeasure} from "../models/unit-of-measure";

@Injectable({
    providedIn: 'root'
})
export class ServiceDefService {

    public URLPath: string = Settings.getInstance().BASE_URL + 'servicedef/servicedef';
    public serviceRegionsURLPath: string = Settings.getInstance().BASE_URL + 'servicedef/serviceregion';
    public regionsURLPath: string = Settings.getInstance().BASE_URL + 'servicedef/region';
    public unitOfMeasurePath: string = Settings.getInstance().BASE_URL + 'general/unitofmeasure';
    
    constructor(private http: HttpClient) { }

    /** Service Definitions **/
    getAllServiceDef(): Observable<any> {
        return this.http.get<any>(this.URLPath)
            .pipe(
                retry(1)
            );
    }
    getServiceDefById(id:number): Observable<any> {
        return this.http.get<any>(this.URLPath + '/'+ id)
            .pipe(
                retry(1)
            );
    }
    getAllServiceDefsForAgency(agencyId: number): Observable<any> {
        return this.http.get<any>(this.URLPath + '/agency/'+ agencyId)
            .pipe(
                retry(1)
            );
    }
    getAllServiceDefsForMatch(agencyId: number): Observable<any> {
        return this.http.get<any>(this.URLPath + '/agencymatch/'+ agencyId)
            .pipe(
                retry(1)
            );
    }
    getAllServiceDefByForeignKey(fkTable: string, fkId: number): Observable<any> {
        return this.http.get<any>(this.URLPath + '/' + fkTable + '/' + fkId)
            .pipe(
                retry(1)
            );
    }
    createServiceDef(record: ServiceDef): Observable<any> {
        return this.http.post(this.URLPath, record)
            .pipe(
                retry(1)
            );
    }
    updateServiceDef(record: ServiceDef): Observable<any> {
        return this.http.put(this.URLPath+'/' + record.id, record)
            .pipe(
                retry(1)
            );
    }
    deleteServiceDef(id: number): Observable<any> {
        return this.http.delete(this.URLPath + '/'+  id)
            .pipe(
                retry(1)
            );
    }
    /** Service Regions **/
    getAllServiceRegions(): Observable<any> {
        return this.http.get<any>(this.serviceRegionsURLPath)
            .pipe(
                retry(1)
            );
    }
    getServiceRegionsByServiceDefId(id: number): Observable<any> {
        return this.http.get<any>(this.serviceRegionsURLPath + '/' + id)
            .pipe(
                retry(1)
            );
    }
    createServiceRegion(record: ServiceRegion): Observable<any> {
        return this.http.post(this.serviceRegionsURLPath, record)
            .pipe(
                retry(1)
            );
    }
    updateServiceRegions(serviceDefId: number, ids: any): Observable<any> {
        return this.http.put(this.serviceRegionsURLPath+'/' + serviceDefId, ids)
            .pipe(
                retry(1)
            );
    }
    deleteServiceRegion(id: number): Observable<any> {
        return this.http.delete(this.serviceRegionsURLPath + '/'+  id)
            .pipe(
                retry(1)
            );
    }
    /*** Regions ***/
    getAllRegions(): Observable<any> {
        return this.http.get<any>(this.regionsURLPath)
            .pipe(
                retry(1)
            );
    }
    createRegion(record: Region): Observable<any> {
        return this.http.post(this.regionsURLPath, record)
            .pipe(
                retry(1)
            );
    }
    updateRegion(record: Region): Observable<any> {
        return this.http.put(this.regionsURLPath + '/' + record.id, record)
            .pipe(
                retry(1)
            );
    }
    deleteRegion(id: number): Observable<any> {
        return this.http.delete(this.regionsURLPath + '/'+  id)
            .pipe(
                retry(1)
            );
    }
    /** unit of measure **/
    getUnitOfMeasures(): Observable<any> {
        return this.http.get<any>(this.unitOfMeasurePath)
            .pipe(
                retry(1)
            );
    }
    getActiveUnitOfMeasures(): Observable<any> {
        return this.http.get<any>(this.unitOfMeasurePath + '/active/')
            .pipe(
                retry(1)
            );
    }
    createUnitOfMeasure(record: UnitOfMeasure): Observable<any> {
        return this.http.post(this.unitOfMeasurePath, record)
            .pipe(
                retry(1)
            );
    }
    updateUnitOfMeasure(record: UnitOfMeasure): Observable<any> {
        return this.http.put(this.unitOfMeasurePath+'/' + record.id, record)
            .pipe(
                retry(1)
            );
    }
    deleteUnitOfMeasure(id: number): Observable<any> {
        return this.http.delete(this.unitOfMeasurePath + '/'+  id)
            .pipe(
                retry(1)
            );
    }
}
